import axios from 'axios'
import {baseUrl, cpsUrl} from 'config/base'
import {ENDPOINT} from 'config/path'
// import {fetchPublicToken} from 'features/Login/login.slice'
import _ from 'lodash'
import {store} from 'redux/store'
import {refreshTokenThunk} from 'redux/thunk.middleware'
import {UpdateLogout, sessionRefreshListener} from 'services/login.service'
import {clearLocalStorageValues} from 'shared/Logout'

axios.defaults.baseURL = baseUrl
axios.defaults.headers.common['Content-Type'] = 'application/json'

const privateApi = axios.create({
    headers: {Accept: 'application/json', 'Cache-Control': 'no-cache, max-age=0'}
})

// request interceptor where we can do some pre operation like format or appending the value before hitting the endpoint
privateApi.interceptors.request.use(
    async (config) => {
        try {
            let response: any
            const state = store.getState()
            const isGuestUser = _.get(state, 'login.loginDetails.securityParams.isGuestUser', false)
            if (localStorage.getItem('auth') !== 'true' && !isGuestUser) {
                response = await sessionRefreshListener(false)
            }
            if (response?.status === 202) {
                const payloadLogout = {
                    newLogin: true,
                    logout: true,
                    userId: state.login.loginDetails.userID
                }
                void UpdateLogout(payloadLogout)
                if (localStorage.getItem('NewLogin') === 'true') {
                    localStorage.setItem('isLoggedIn', 'false')
                    localStorage.setItem('sessionTimedOut', 'true')
                    window.location.href = `${cpsUrl}${ENDPOINT.basePath}${ENDPOINT.login}`
                } else {
                    window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
                }
            } else {
                const accessToken = state?.login?.authToken?.data?.access_token
                const isLoggedIn = localStorage.getItem('isLoggedIn')
                if (isLoggedIn === 'true') {
                    config.headers.Authorization = `Bearer ${accessToken}`
                }
            }
            // Process the response data here if needed
        } catch (error) {
            // Handle any errors that occurred during the API call
        }

        return config
    },
    async (error) =>
        // Handle request errors
        await Promise.reject(error)
)

privateApi.interceptors.response.use(
    function (response) {
        return response
    },
    async function (error) {
        const originalRequest = error.config
        const state = store.getState()
        const refreshToken = _.get(state, 'login.authToken.data.refresh_token', '')
        error.config.__retryCount = error.config.__retryCount || 0
        // if endpoint returns 401 and retry option is false i.e., we have one retry option
        if (error.response.status === 401 && !originalRequest._retry && error.config.__retryCount < 1) {
            error.config.__retryCount = parseInt(error.config.__retryCount) + 1
            const dispatch = store.dispatch
            const payload = {
                refresh_token: refreshToken,
                grant_type: 'refresh_token'
            }
            await dispatch(refreshTokenThunk(payload))
            error.config.headers.Authorization = `Bearer ${_.get(state, 'login.authToken.data.access_token', '')}`
            return await privateApi.request(error.config)
        } else if (error.response.status === 401) {
            clearLocalStorageValues()
            localStorage.setItem('isLoggedIn', 'false')
            if (localStorage.getItem('NewLogin') === 'true') {
                window.location.href = `${cpsUrl}${ENDPOINT.basePath}${ENDPOINT.homepage}`
            } else {
                window.location.href = `${cpsUrl}/lmsweb/signon.jsp`
            }
        }
        return await Promise.reject(error)
    }
)

// const publicApi = axios.create({
//     headers: {Accept: 'application/json', 'Cache-Control': 'no-cache, max-age=0'}
// })
const api = axios.create({
    headers: {Accept: 'application/json', 'Cache-Control': 'no-cache, max-age=0'}
})

// Add request interceptor to inject public token
// publicApi.interceptors.request.use(
//     async (config) => {
//         const publicToken = store.getState().login.publicToken
//         if (!publicToken?.token || Date.now() > publicToken?.expiryTimeStamp) {
//             const dispatch = store.dispatch
//             await dispatch(fetchPublicToken())
//         }
//         if (publicToken.token) {
//             config.headers.Authorization = `Bearer ${publicToken.token}`
//         }
//         return config
//     },
//     async (error) => await Promise.reject(error)
// )

// publicApi.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config

//         if (error?.response?.status === 401 && !originalRequest?._retry) {
//             originalRequest._retry = true
//             const dispatch = store.dispatch
//             await dispatch(fetchPublicToken())

//             const updatedToken = store?.getState()?.login?.publicToken?.token
//             if (updatedToken) {
//                 originalRequest.headers.Authorization = `Bearer ${updatedToken}`
//                 return await publicApi.request(originalRequest)
//             }
//         }
//         return await Promise.reject(error)
//     }
// )

export {privateApi}
export default api
